interface GeoRect {
  latMin: number;
  latMax: number;
  lonMin: number;
  lonMax: number;
  method: string;
}

const GEO_RULES: GeoRect[] = [
  // Saudi Arabia / Gulf
  { latMin: 12, latMax: 32.5, lonMin: 34, lonMax: 60, method: "umm_al_qura" },
  // Pakistan, Afghanistan, India, Bangladesh
  { latMin: 5, latMax: 38, lonMin: 60, lonMax: 93, method: "karachi" },
  // Iran
  { latMin: 25, latMax: 40, lonMin: 44, lonMax: 63.5, method: "tehran" },
  // North Africa + Levant
  { latMin: 15, latMax: 38, lonMin: -17, lonMax: 36, method: "egyptian" },
  // Sub-Saharan Africa
  { latMin: -35, latMax: 15, lonMin: -17, lonMax: 52, method: "egyptian" },
  // North America
  { latMin: 15, latMax: 72, lonMin: -170, lonMax: -50, method: "isna" },
];

export function suggestMethod(latitude: number, longitude: number): string {
  for (const rule of GEO_RULES) {
    if (
      latitude >= rule.latMin &&
      latitude <= rule.latMax &&
      longitude >= rule.lonMin &&
      longitude <= rule.lonMax
    ) {
      return rule.method;
    }
  }
  return "mwl";
}
